import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Cleft Lip Surgery Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MS - ENT, Fellowship - Craniofacial Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Pediatric Cleft Surgery Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MDS - Oral Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Cleft Palate Reconstruction Specialist"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MS - General Surgery, Fellowship - Pediatric Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Cleft Lip Revision Expert"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Cleft Surgery"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MD - Pediatrics, Fellowship - Cleft Care",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Comprehensive Cleft Care"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Cleft Lip Treatment Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert comprehensive care for cleft lip and palate with multidisciplinary approach for optimal functional and aesthetic outcomes.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const CleftLipTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Cleft Lip Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Comprehensive Cleft Care with 95% Success Rate. Multidisciplinary Approach for Optimal Functional and Aesthetic Outcomes.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Newborn Cleft Care
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>95%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Surgical Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>3-6</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Months Ideal Surgery Age</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>8+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Specialist Team Members</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Years Expert Team</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "types", label: "Types", icon: "🔍" },
              { id: "treatment", label: "Treatment", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "team", label: "Team Approach", icon: "👥" },
              { id: "faq", label: "FAQ", icon: "❓" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Cleft Lip Treatment</span>
            </h2>
          </div>

          {/* What is Cleft Lip */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Cleft Lip and Palate
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Cleft lip and cleft palate are birth defects that occur when a baby's lip or mouth do not form 
                properly during pregnancy. A cleft lip is a physical separation of the two sides of the upper lip, 
                often including the bones of the upper jaw and/or upper gum. A cleft palate is an opening in the 
                roof of the mouth that can affect both the hard and soft palate.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Embryological Development</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Occurs during early pregnancy (4th to 7th week) when facial structures that normally 
                      fuse together fail to connect properly, leaving an opening that can affect lip, gum, 
                      and palate development.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Global Incidence</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Cleft lip and palate affects approximately 1 in 700 newborns worldwide, making it one 
                      of the most common birth defects. Early intervention and comprehensive care are crucial 
                      for optimal outcomes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Types & Classification */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of Cleft Lip and Palate
            </h3>

            <div className="row">
              {[
                {
                  title: "Unilateral Cleft Lip", 
                  description: "Opening on one side of the lip that may extend into the nose, can be complete or incomplete",
                  details: "Most common type, affects left side more frequently"
                },
                {
                  title: "Bilateral Cleft Lip", 
                  description: "Openings on both sides of the lip creating a central tissue mass that hangs freely",
                  details: "More complex reconstruction required"
                },
                {
                  title: "Complete Cleft Lip", 
                  description: "Full separation extending from the lip through the floor of the nose",
                  details: "Involves lip, nostril, and alveolar ridge"
                },
                {
                  title: "Incomplete Cleft Lip", 
                  description: "Partial separation that doesn't extend completely into the nose, may appear as a notch",
                  details: "Milder form, sometimes called microform cleft"
                },
                {
                  title: "Cleft Palate Only", 
                  description: "Opening in the roof of the mouth without lip involvement, can affect speech and feeding",
                  details: "Often detected later than cleft lip"
                },
                {
                  title: "Submucous Cleft", 
                  description: "Hidden cleft under the mucous membrane of the palate, may not be visibly apparent",
                  details: "Can cause speech and feeding difficulties"
                }
              ].map((type, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {type.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {type.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {type.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Comprehensive Classification */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Cleft Classification
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Unilateral Incomplete Cleft Lip",
                    description: "Partial separation on one side not extending into nose, may involve vermilion border only",
                    treatment: "Primary repair at 3-6 months, simpler reconstruction"
                  },
                  {
                    type: "Unilateral Complete Cleft Lip",
                    description: "Full separation on one side extending into nasal floor, often with nasal deformity",
                    treatment: "Primary cheiloplasty with nasal correction, multidisciplinary approach"
                  },
                  {
                    type: "Bilateral Complete Cleft Lip",
                    description: "Full separations on both sides with protruding premaxilla, most complex type",
                    treatment: "Staged surgery, possible presurgical orthopedics, complex reconstruction"
                  },
                  {
                    type: "Isolated Cleft Palate",
                    description: "Opening in roof of mouth without lip involvement, affects soft and/or hard palate",
                    treatment: "Palatoplasty at 9-18 months, speech therapy, feeding support"
                  },
                  {
                    type: "Cleft Lip and Palate",
                    description: "Combination of lip and palate clefts, most comprehensive treatment needs",
                    treatment: "Multiple staged surgeries, full multidisciplinary team care"
                  },
                  {
                    type: "Robin Sequence",
                    description: "Triad of micrognathia, glossoptosis, and cleft palate, breathing difficulties",
                    treatment: "Airway management first, then staged surgical corrections"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes & Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Genetic Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Family history of cleft lip/palate</li>
                      <li style={{ marginBottom: "10px" }}>Genetic syndromes (Van der Woude, Stickler)</li>
                      <li style={{ marginBottom: "10px" }}>Chromosomal abnormalities</li>
                      <li style={{ marginBottom: "10px" }}>Ethnic background (higher in Asian populations)</li>
                      <li>Specific gene mutations affecting facial development</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Environmental Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Maternal smoking during pregnancy</li>
                      <li style={{ marginBottom: "10px" }}>Alcohol consumption during pregnancy</li>
                      <li style={{ marginBottom: "10px" }}>Certain medications (anti-seizure drugs)</li>
                      <li style={{ marginBottom: "10px" }}>Maternal diabetes</li>
                      <li>Nutritional deficiencies (folic acid)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Timeline
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Early Intervention (Birth - 3 Months)
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Critical period focused on feeding support, parental education, and preparation for 
                    surgical intervention through multidisciplinary assessment.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Initial Management:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Feeding assessment and support</li>
                          <li style={{ marginBottom: "8px" }}>Cleft team evaluation</li>
                          <li style={{ marginBottom: "8px" }}>Genetic counseling</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Presurgical orthopedics if needed</li>
                          <li style={{ marginBottom: "8px" }}>Airway management for severe cases</li>
                          <li style={{ marginBottom: "8px" }}>Parental support and education</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Feeding Support:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Specialized bottles and nipples</li>
                      <li style={{ marginBottom: "8px" }}>Positioning techniques</li>
                      <li style={{ marginBottom: "8px" }}>Feeding therapy sessions</li>
                      <li>Nutritional monitoring and support</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical & Long-term Care
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Timeline:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Cleft lip repair: 3-6 months</li>
                      <li style={{ marginBottom: "10px" }}>Cleft palate repair: 9-18 months</li>
                      <li style={{ marginBottom: "10px" }}>Speech surgery: 3-5 years if needed</li>
                      <li style={{ marginBottom: "10px" }}>Alveolar bone graft: 7-11 years</li>
                      <li>Rhinoplasty/revisions: teenage years</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Ancillary Services:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Speech and language therapy</li>
                      <li style={{ marginBottom: "10px" }}>Audiology and hearing services</li>
                      <li style={{ marginBottom: "10px" }}>Dental and orthodontic care</li>
                      <li style={{ marginBottom: "10px" }}>Psychological support</li>
                      <li>Genetic counseling and testing</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Follow-up:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Annual team assessments until age 21</li>
                      <li style={{ marginBottom: "10px" }}>Growth and development monitoring</li>
                      <li>Transition to adult care services</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Surgical Procedure Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgical Procedure & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Day 1-3",
                    title: "Immediate Post-op",
                    activities: ["Hospital stay for monitoring", "Pain management", "Arm restraints to protect surgery", "Initial feeding assessment"]
                  },
                  {
                    period: "Day 4-7",
                    title: "Early Recovery",
                    activities: ["Suture line care begins", "Swelling starts to decrease", "Gradual return to feeding", "Wound healing assessment"]
                  },
                  {
                    period: "Week 2-4",
                    title: "Healing Phase",
                    activities: ["Suture removal if needed", "Most swelling resolved", "Normal feeding established", "Scar management begins"]
                  },
                  {
                    period: "Month 2-3",
                    title: "Final Results",
                    activities: ["Complete healing achieved", "Final aesthetic results visible", "Follow-up with team", "Long-term planning"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Team Approach */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Multidisciplinary Team Approach
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Core Team Members</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Plastic/Craniofacial Surgeon - surgical reconstruction</li>
                      <li style={{ marginBottom: "10px" }}>Pediatrician - overall health and development</li>
                      <li style={{ marginBottom: "10px" }}>ENT Specialist - ear and hearing issues</li>
                      <li>Orthodontist - dental and jaw alignment</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Support Specialists</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Speech-Language Pathologist - feeding and speech</li>
                      <li style={{ marginBottom: "10px" }}>Audiologist - hearing assessment</li>
                      <li style={{ marginBottom: "10px" }}>Genetic Counselor - inheritance patterns</li>
                      <li>Psychologist - emotional and social support</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "At what age should cleft lip surgery be performed?",
                  answer: "Cleft lip surgery is typically performed when the baby is 3 to 6 months old. This timing is based on the 'Rule of 10s' - the baby should be at least 10 weeks old, weigh at least 10 pounds, and have a hemoglobin level of at least 10 grams per deciliter. This age is ideal because the baby is old enough to safely undergo anesthesia but young enough that the facial structures are still very malleable and healing potential is excellent. Early repair allows for better feeding, reduces the risk of ear infections, and supports normal speech development. The exact timing may vary depending on the baby's overall health, the type and severity of the cleft, and the surgical team's assessment. Some complex cases or babies with other health issues may require delayed surgery, but the 3-6 month window remains the standard for most unilateral cleft lip repairs."
                },
                {
                  question: "Can cleft lip be detected during pregnancy?",
                  answer: "Yes, cleft lip can often be detected during pregnancy through routine ultrasound examinations. Most cleft lips are visible on ultrasound around the 18-20 week anatomy scan, when the facial features are clearly developed. However, the detection rate varies - isolated cleft lips are more easily detected (approximately 75-80% detection rate) than cleft palates alone (which are much harder to see on ultrasound). Factors affecting detection include the skill of the sonographer, the quality of the ultrasound equipment, the position of the baby, and the severity of the cleft. When a cleft is suspected or diagnosed prenatally, families are typically referred to a comprehensive cleft team for counseling and planning. Early diagnosis allows parents to prepare emotionally, learn about feeding techniques, and establish care with the appropriate specialists before the baby is born, ensuring a smooth transition to treatment after delivery."
                },
                {
                  question: "How many surgeries will my child need for cleft lip and palate?",
                  answer: "The number of surgeries required for comprehensive cleft care varies depending on the severity of the condition, but most children with both cleft lip and palate will require multiple procedures throughout their childhood and adolescence. The typical surgical timeline includes: Primary lip repair at 3-6 months; Primary palate repair at 9-18 months; Possible ear tube placement for hearing; Possible speech surgery around age 5 if needed; Alveolar bone graft between ages 7-11; Possible jaw surgery in teenage years if needed; Final nasal revision in late teens. Some children may require additional procedures for complications or revisions. The exact number and timing of surgeries are determined by the cleft team based on the child's individual needs, growth patterns, and functional requirements. The goal is to complete major reconstructive surgeries by the time facial growth is complete, typically around age 18-21."
                },
                {
                  question: "Will my child have normal speech after cleft palate repair?",
                  answer: "Most children who undergo timely and successful cleft palate repair develop normal or near-normal speech. The palate is crucial for speech because it helps create pressure for certain sounds and prevents air from escaping through the nose. Early palate repair (typically between 9-18 months) is essential for normal speech development. However, some children may develop characteristic 'cleft palate speech' even after repair, which can include hypernasality, nasal air emission, or articulation errors. About 20-30% of children require additional speech therapy or secondary surgery to address persistent speech issues. Factors that influence speech outcomes include the severity of the original cleft, the timing and quality of the surgical repair, hearing status, and the child's cognitive development. Regular follow-up with speech-language pathologists from the cleft team is crucial for monitoring speech development and intervening early if problems arise. With comprehensive care, the vast majority of children achieve functional, intelligible speech."
                },
                {
                  question: "Is cleft lip hereditary?",
                  answer: "Cleft lip and palate can have a hereditary component, but most cases occur in families with no previous history. The inheritance pattern is complex and considered multifactorial, meaning both genetic and environmental factors play a role. When one child in a family has a cleft lip/palate, the risk for future children is approximately 2-5%. If one parent has a cleft, the risk for their children is about 2-6%. If both parents have clefts, the risk increases to 15-20%. However, when cleft lip/palate occurs as part of a genetic syndrome, the inheritance pattern follows that specific syndrome's genetics. Genetic counseling is recommended for families affected by cleft conditions to understand their specific risks. It's important to note that even with genetic predisposition, most babies with cleft lip/palate are born to parents with no family history of the condition. Ongoing research continues to identify specific genes and environmental factors that contribute to cleft formation."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Comprehensive Cleft Care Available
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our multidisciplinary team provides complete cleft care from birth through adulthood for optimal functional and aesthetic outcomes.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Cleft Surgery: <strong>080-6541-7705</strong> | Pediatric Care: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default CleftLipTreatment;